import { useTranslation } from 'react-i18next';
import { Chip, Grid, Paper, Stack, Typography } from '@mui/material';
import { RangePlanningItem } from '../types';

interface SupplierDetailsTabProps {
  item: RangePlanningItem;
}

/** Read-only in this demo - flag-for-review action lives in App.tsx wiring via the parent
 * detail page (see ItemDetail.tsx flagForSupplierReview call), not duplicated here. */
const SupplierDetailsTab = ({ item }: SupplierDetailsTabProps) => {
  const { t } = useTranslation('rangePlanningItems');
  const { supplier } = item;

  return (
    <Paper variant="outlined"
      sx={{ p: 4 }}>
      <Grid container
        spacing={5}>
        <Grid item
          md={4}
          sm={6}
          xs={12}>
          <Stack spacing={0.5}>
            <Typography variant="textXS"
              color="text.secondary">{t('supplierName', 'Supplier')}</Typography>
            <Typography variant="textMD"
              fontWeight={600}>{supplier.supplierName}</Typography>
          </Stack>
        </Grid>
        <Grid item
          md={4}
          sm={6}
          xs={12}>
          <Stack spacing={0.5}>
            <Typography variant="textXS"
              color="text.secondary">{t('supplierCode', 'Supplier Code')}</Typography>
            <Typography variant="textMD"
              fontWeight={600}>{supplier.supplierCode}</Typography>
          </Stack>
        </Grid>
        <Grid item
          md={4}
          sm={6}
          xs={12}>
          <Stack spacing={0.5}>
            <Typography variant="textXS"
              color="text.secondary">{t('leadTimeDays', 'Lead Time (days)')}</Typography>
            <Typography variant="textMD"
              fontWeight={600}>{supplier.leadTimeDays}</Typography>
          </Stack>
        </Grid>
        <Grid item
          md={4}
          sm={6}
          xs={12}>
          <Stack spacing={0.5}>
            <Typography variant="textXS"
              color="text.secondary">{t('minimumOrderQuantity', 'Minimum Order Quantity')}</Typography>
            <Typography variant="textMD"
              fontWeight={600}>{supplier.minimumOrderQuantity}</Typography>
          </Stack>
        </Grid>
        <Grid item
          xs={12}>
          <Stack spacing={1}>
            <Typography variant="textXS"
              color="text.secondary">{t('alternateSuppliers', 'Alternate Suppliers')}</Typography>
            <Stack direction="row"
              spacing={1}
              flexWrap="wrap"
              useFlexGap>
              {supplier.alternateSuppliers.length === 0 && (
                <Typography variant="textSM"
                  color="text.secondary">{t('noAlternateSuppliers', 'No alternate suppliers recorded.')}</Typography>
              )}
              {supplier.alternateSuppliers.map((name) => (
                <Chip key={name}
                  label={name}
                  size="small"
                  variant="outlined" />
              ))}
            </Stack>
          </Stack>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default SupplierDetailsTab;
